<script lang="ts">
	import { onDestroy } from "svelte";
	import { isItemListUpdating, getItems } from "../../stores/stores.itemList";
	import { mediaQuery } from "../../../generic/scripts/mediaquery.store";
	import Icon from "../../../generic/components/Icon.svelte";
	import {CONFIG_SERP_PAGE as CONFIG} from "../../serpPage.config";
	const { MANAGE_TIMEOUT } = CONFIG.SEARCHES;

	let items: string;
	export let itemListName: string;
	export let itemListId: string;
	let timeoutInstance: number | undefined;

	const isItemListUpdatingUnsubscribe = isItemListUpdating.subscribe(isUpdate => {
		if (isUpdate) {
			clearTimeout(timeoutInstance);
			timeoutInstance = setTimeout(() => {
				getItems().then(freshItems => {
					items = freshItems;
					EC.notifier.events.ItemListReload.notify();
				});
			}, MANAGE_TIMEOUT);
		}
	});

	onDestroy(isItemListUpdatingUnsubscribe);

	// this should be in sync with grid classess (eg. grid-cols-2 grid-lg-cols-4)
	function getItemsPerRow() {
		switch ($mediaQuery) {
			case "lg":
				return 4;
			default:
				return 2;
		}
	}
</script>

{#if $isItemListUpdating}
	<div class="placeholder-wrapper placeholder-list-item" aria-hidden="true">
		<div class="grid grid-gap-2 grid-cols-2 grid-lg-cols-4" data-itemListName={itemListName} data-itemListId={itemListId}>
			{#each Array(getItemsPerRow()) as _}
				<!-- TODO not working properly -->
				<Icon template="ph-list-item" height={null} width={null} />
			{/each}
		</div>
	</div>
{:else}
	<div class="grid grid-gap-2 grid-cols-2 grid-lg-cols-4" data-itemListName="{itemListName}" data-itemListId="{itemListId}">
		{@html items}
	</div>
{/if}
